import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { useDeleteUserTransponder, useGetUserTransponder } from "@app/store/service/connectorService"
import { getDateString } from "@app/utils/localeUtils"
import { faDiamond } from "@fortawesome/free-solid-svg-icons/faDiamond"
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare"
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Modal, useModal } from "@tecreation/funnel-components"
import { AnimatePresence, m } from "framer-motion"
import { useEffect, useState } from "react"
import { AddTransponder } from "./components/AddTransponder/AddTransponder"
import { MyParadiseDeleteTransponderModal } from "./components/MyParadiseDeleteTransponderModal"
import { MyParadiseTransponderEditModal } from "./components/MyParadiseTransponderEditModal/MyParadiseTransponderEditModal"

export const MyParadiseTransponderModal = () => {
	const { data: strings } = useGetStrings(undefined, { defaultData: {} })
	const { data: dataTransponders, refetch } = useGetUserTransponder()
	const [deleteUserTransponder] = useDeleteUserTransponder()

	const [showEditModal, setShowEditModal] = useState(false)
	const [showDeleteDialog, setShowDeleteDialog] = useState(false)
	const [defaultTransponder, setDefaultTransponder] = useState()
	const [currentTransponder, setCurrentTransponder] = useState()
	const [addResponderToggle, setAddResponderToggle] = useState(false)

	const { hideModal } = useModal()

	const { transponderModalInformationText, buttonAddTransponder, placeholderBirthday, transponderModalHeader, transponderModalTranspondersText } = strings

	useEffect(() => {
		if (dataTransponders) {
			const defaultIndex = dataTransponders.findIndex(obj => {
				return obj.isDefault === true
			})
			setDefaultTransponder(dataTransponders[defaultIndex])
		}
	}, [dataTransponders])

	const deleteTransponder = async () => {
		let result = await deleteUserTransponder(currentTransponder.transponderId)
		if (result) {
			setShowDeleteDialog(false)
			setCurrentTransponder(null)
			hideModal()
			refetch()
		}
	}

	return (
		<Modal className="customModal">
			<Modal.Header>{transponderModalHeader}</Modal.Header>
			<Modal.Closer />
			{showEditModal && (
				<div style={{ position: "absolute", backgroundColor: "rgba(0,0,0,0.7)", minHeight: "auto" }} className="h-100 w-100 flex flex-center z-9">
					<MyParadiseTransponderEditModal
						refetch={refetch}
						defaultTransponder={defaultTransponder}
						currentTransponder={currentTransponder}
						onClose={() => setShowEditModal(false)}
					/>
				</div>
			)}
			{showDeleteDialog && (
				<div style={{ position: "absolute", backgroundColor: "rgba(0,0,0,0.7)" }} className="h-100 w-100 flex flex-center z-9">
					<MyParadiseDeleteTransponderModal
						onClose={() => {
							setShowDeleteDialog(false)
						}}
						onDelete={deleteTransponder}
					/>
				</div>
			)}
			<Modal.Body>
				<p className="color-fg-default f4 mb-3"> {transponderModalInformationText}</p>
				<Button style="secondary" onClick={() => setAddResponderToggle(addResponderToggle ? false : true)}>
					{buttonAddTransponder}
				</Button>
				{dataTransponders && (
					<div className="color-fg-default mt-3">
						<div className="f3 border-bottom border-color-primary-100">{transponderModalTranspondersText}</div>
						{dataTransponders.map((transponder, i) => (
							<div key={i} className="flex mt-3">
								<div className="flex flex-items-baseline mr-8">
									{transponder.isDefault ? (
										<FontAwesomeIcon icon={faDiamond} size="xs" style={{ color: "black" }} />
									) : (
										<FontAwesomeIcon icon={faDiamond} size="xs" style={{ color: "#ffffff" }} />
									)}
									<p className="ml-2 color-fg-primary">{transponder.exportCode}</p>
								</div>
								<div className=" flex flex-column w-100">
									<p className="f5 mb-1">{transponder.firstName + " " + transponder.lastName}</p>
									<p className="f5 mb-1">{placeholderBirthday}</p>
									<p className="f5">{getDateString(new Date(transponder.birthDate))}</p>
								</div>
								<div className=" flex flex-column flex-items-end w-100">
									<FontAwesomeIcon
										icon={faTrash}
										size="xs"
										className="color-fg-secondary mb-1"
										onClick={() => {
											;(setCurrentTransponder(transponder), setShowDeleteDialog(true))
										}}
									/>
									<FontAwesomeIcon
										icon={faPenToSquare}
										size="xs"
										className="color-fg-secondary"
										onClick={() => {
											;(setCurrentTransponder(transponder), setShowEditModal(true))
										}}
									/>
								</div>
							</div>
						))}
					</div>
				)}
				<AnimatePresence>
					{addResponderToggle && (
						<m.div
							className="of-hidden w-100"
							style={{ originY: 0 }}
							initial={{
								key: "modal",
								height: 0,
							}}
							animate={{
								height: "auto",
								transition: {
									duration: 0.3,
								},
							}}
							exit={{
								height: 0,
								transition: { duration: 0.3 },
							}}
						>
							<AddTransponder defaultTransponder={defaultTransponder} refetch={refetch} />
						</m.div>
					)}
				</AnimatePresence>
			</Modal.Body>
		</Modal>
	)
}
